import { Link } from 'react-router-dom';
import React from 'react';
import { ButtonBase, IconButton } from '@mui/material';

import HomeIcon from '@mui/icons-material/Home';

const HomeSection = () => (
    <ButtonBase disableRipple component={Link} to={'/menu'}>
        <IconButton>
            <HomeIcon />
        </IconButton>
    </ButtonBase>
);

export default HomeSection;